// #region order enum
export enum ComplianceType {
  Default = 0,
  GdprCompliance = 1,
}

export enum ContactFormType {
  None = 0,
  Email = 1,
  Intercom = 2,
  WebView = 3,
}

export enum WebToAppRedirect {
  NoRedirect = 0,
  RedirectOnce = 1,
  RedirectAlways = 2,
  SuggestPwa = 3,
  ForcePwa = 4,
}
// #endregion

// #region app config types
export interface AppConfig {
  AppDesignScheme: AppDesignScheme;
  AppNameId: string;
  AppStoreId: string;
  AppStoreUrl: string | null;
  BrandLogoUrl: string | null;
  BrandName: string | null;
  Category: number;
  ComplianceType: ComplianceType;
  ContactFormType: ContactFormType;
  CookiePolicyUrl?: string;
  CountryCode?: string;
  DataOffset?: number;
  DeliveryAddressLayout: number;
  DeliveryEnabled: boolean;
  DineInEnabled: boolean;
  DisplayConsentToSaveCard: boolean;
  DisplayCuisineTypeListAndRestaurantSearchBar: boolean;
  DisplayDeliveryRestaurantListScreen: boolean;
  DisplayFreeCokeSideMenuItem: boolean;
  DisplayPickupRestaurantListScreen: boolean;
  DisplayUserRestaurantRatings: boolean;
  EnterPhoneNumberScreenTermsMessage: EnterPhoneNumberScreenTermsMessage;
  FacebookTokens: string[];
  Features: string[];
  GoogleAnalyticsTokens: string[];
  GoogleMapsApiKeyWeb: string;
  Hostname: string;
  IntercomAppId: string;
  IntercomToken: string;
  IsEmbed: boolean;
  Languages: [Language];
  MapBoundryMaxLatitude: number;
  MapBoundryMaxLongitude: number;
  MapBoundryMinLatitude: number;
  MapBoundryMinLongitude: number;
  MapCenterLatitude: number;
  MapCenterLongitude: number;
  MixpanelToken: string;
  PhoneNumberConfig: PhoneNumberConfig;
  PickupEnabled: boolean;
  PlayStoreUrl: string | null;
  PostCodeInputLabel: string | null;
  PrivacyPolicyUrl?: string;
  ShareMessageEmailMessage?: string;
  ShareMessageEmailSubject?: string;
  ShareMessageEmailUrl?: string;
  ShareMessageFacebookMessage?: string;
  ShareMessageFacebookUrl?: string;
  ShareMessageGenericMessage?: string;
  ShareMessageGenericUrl?: string;
  ShareMessageSmsMessage?: string;
  ShareMessageSmsUrl?: string;
  ShareMessageTwitterMessage?: string;
  ShareMessageTwitterUrl?: string;
  ShareMessageWhatsAppMessage?: string;
  ShareMessageWhatsAppUrl?: string;
  TermsAndConditionsUrl?: string;
  TipsEnabled: boolean;
  ViewportTopOffset?: number;
  WebOrderUiVersion?: string;
  WebToAppRedirect: WebToAppRedirect;
  WhiteLabelId: number;
}

export interface AppDesignScheme {
  Primary: string;
  Secondary: string;
  Tertiary: string;
  Font?: string;
}

interface EnterPhoneNumberScreenTermsMessage {
  LinkText: string;
  LinkUrl: string;
  Text: string;
}

export interface Language {
  LangageId: string;
  Name: string;
}

export interface PhoneNumberConfig {
  Prefix: string;
  AutocompletePhoneNumberLength: number;
}
// #endregion
